export const MAX_SURVEY_TEXT_LENGTH = 20_000
export const EXTEND_TRIAL_SURVEY_NAME = 'extendTrial'
// Microsoft-billed trial admins can't get a Stripe extension, so they answer a
// shorter feedback survey; its responses are stored under this name.
export const MS_TRIAL_FEEDBACK_SURVEY_NAME = 'msTrialFeedback'
export const SURVEY_TRIAL_EXTEND_COUPON_CODE = 'surveyTrialExtend'
export const EXTEND_TRIAL_GRANTED_DAYS = 14

// Constant GSI partition key stamped on every stored response so the vtadmin
// view can query them all in one shot, sorted by timestamp (see the
// SurveyResponseView "ResponsesByTimestamp" index).
export const SURVEY_RESPONSE_ENTITY_TYPE = 'surveyResponse'

// Stable error codes the submit-survey backend returns (as the GraphQL error
// message) so the UI can map each to a localized, user-friendly message.
export const TRIAL_EXTENSION_ERROR_CODES = {
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
  ALREADY_EXTENDED: 'ALREADY_EXTENDED',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  STRIPE_FAILED: 'STRIPE_FAILED',
  SURVEY_NOT_FOUND: 'SURVEY_NOT_FOUND',
} as const

export type TrialExtensionErrorCode = (typeof TRIAL_EXTENSION_ERROR_CODES)[keyof typeof TRIAL_EXTENSION_ERROR_CODES]

export const TRIAL_EXTENSION_FALLBACK_ERROR_MESSAGE_KEY = 'survey.extendTrial.error.submitFailed'

export const TRIAL_EXTENSION_ERROR_MESSAGE_KEYS: Record<TrialExtensionErrorCode, string> = {
  NOT_ELIGIBLE: 'survey.extendTrial.error.notEligible',
  ALREADY_EXTENDED: 'survey.extendTrial.error.alreadyExtended',
  VALIDATION_FAILED: 'survey.extendTrial.error.validationFailed',
  STRIPE_FAILED: TRIAL_EXTENSION_FALLBACK_ERROR_MESSAGE_KEY,
  SURVEY_NOT_FOUND: TRIAL_EXTENSION_FALLBACK_ERROR_MESSAGE_KEY,
}
